const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getAffiliate = async (page = 1, perPage = 10) => {
    const token = localStorage.getItem('token');

    if (!token) {
        throw new Error('Токен авторизации не найден.');
    }

    try {
        const response = await fetch(`${API_BASE_URL}/admin/user/affiliator-accounts?page=${page}&per_page=${perPage}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw { ...errorData, statusCode: response.status };
        }

        const result = await response.json();

        return {
            data: result.data || [],
            meta: {
                total_count: result.meta?.total || 0,
                current_page: result.meta?.current_page || page,
                per_page: result.meta?.per_page || perPage,
                total_pages: result.meta?.last_page || 1
            }
        };

    } catch (error) {
        console.error('[getAffiliate] Ошибка сети или другая ошибка:', error);
        throw error;
    }
};